import { GotoAction } from '../router/simple-router.actions';

export class GotoError extends GotoAction {
  static readonly type = '[Error] Goto error';
}
